module.exports = __webpack_public_path__ + "img/Menu.c145d4fb.svg";